import React from 'react';
import { Context } from '../../App';
import { PropertyKey, PropertyKeyModel } from '../../model/property';
import ModelInput from '../../base-components/ModelInput';
import Card from '../../base-components/Card';
import useModel from '../../base-components/hooks/useModel';
import EditorParent from '@/base-components/EditorParent';
import { deletePropertyKey } from '@/api/property-key-controller';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from '@/generic/config';
import { DropdownItem } from '@/api/base/dropdown-item';

const OBJECT_TYPE_ITEMS: DropdownItem[] = [
    { id: 'worksite', name: 'Worksite' },
    { id: 'order', name: 'Order' },
    { id: 'customer', name: 'Customer' },
];

const PROPERTY_TYPE_ITEMS: DropdownItem[] = [
    { id: 'STRING', name: 'STRING' },
    { id: 'BOOLEAN', name: 'BOOLEAN' },
];

const PropertyPage: React.FC = () => {
    const { translations } = React.useContext(Context);
    const { model, toolbar } = useModel<PropertyKey>(PropertyKeyModel);
    const navigate = useNavigate();
    const tm = translations.model.propertyKey;

    const title = model.isNew
        ? translations.systemSettings.propertyKey.create
        : `${tm.search.title} — ${model.object.key} (${model.object.id})`;

    const actions = model.isNew ? [] : [
        {
            title: tm.delete,
            onClick: async () => {
                await deletePropertyKey(model.object);
                navigate(RoutePath.Properties);
            },
        },
    ];

    return (
        <EditorParent title={title} toolbar={toolbar} actions={actions}>
            <Card title={tm.search.title} description={translations.systemSettings.propertyKey.description}>
                <ModelInput title={tm.objectType} fieldKey="objectType" model={model} kind="dropdown" dropdownProps={{ items: OBJECT_TYPE_ITEMS }} />
                <ModelInput title={tm.key} fieldKey="key" model={model} />
                <ModelInput title={tm.propertyType} fieldKey="propertyType" model={model} kind="dropdown" dropdownProps={{ items: PROPERTY_TYPE_ITEMS }} />
            </Card>
        </EditorParent>
    );
};

export default PropertyPage;
